module.exports = __webpack_public_path__ + "static/img/Inspection21.a5c41767.jpg";